import styled from 'styled-components';

export const Tag = styled.span`
    background-color: #aaa;
    color: #fff;
    border-radius: 16px;
    padding: 8px;
    margin: 2px;
`;